<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th class="text-center">#</th>
          <th>Dias da Semana</th>
          <th>Hora</th>
          <th class="text-center">Status</th>
          <th>Criado por</th>
          <th>Atualizado por</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="ds in distributionSetups" :key="ds.distributionSetupId">
          <td class="text-center">{{ ds.id }}</td>
          <td>{{ formatDaysOfWeek(ds.daysOfWeek) }}</td>
          <td>{{ ds.hour }}</td>
          <td v-html="statusTranslate(ds.status)" class="text-center" />
          <td>
            {{ createdUpdatedUser(ds.createdBy, ds.createdAt) }}
          </td>
          <td>
            {{ createdUpdatedUser(ds.updatedBy, ds.updatedAt) }}
          </td>
          <td class="text-center p-2">
            <button
              type="button"
              class="btn btn-outline-warning btn-icon"
              title="Editar"
              @click="$emit('createEditDistribution', ds.id)"
            >
              <i class="ph ph-pencil" />
            </button>
            <button
              type="button"
              class="btn btn-outline-info btn-icon ms-2"
              title="Rodar Manualmente"
              @click="$emit('runDistribution', ds.id)"
            >
              <i class="ph ph-play" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { createdUpdatedUser, statusTranslate } from '@/utils/strings'

export default {
  name: 'ListDistributionSetups',

  props: {
    distributionSetups: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListDistributionSetups',
        columnDefs: [
          {
            targets: [4, 5, 6],
            orderable: false,
          },
          {
            targets: [6],
            width: 130,
          },
        ],
      },
      createdUpdatedUser,
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },

    formatDaysOfWeek(daysOfWeek) {
      const daysOfWeekMap = {
        0: 'Domingo',
        1: 'Segunda-feira',
        2: 'Terça-feira',
        3: 'Quarta-feira',
        4: 'Quinta-feira',
        5: 'Sexta-feira',
        6: 'Sábado',
      }
      const strDaysOfWeek = daysOfWeek.replace('[', '').replace(']', '')
      const arrayDaysOfWeek = strDaysOfWeek.split(',')

      return arrayDaysOfWeek.map((day) => daysOfWeekMap[day]).join(', ')
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
